"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Hylia web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * DefaultApi - axios parameter creator
 * @export
 */
exports.DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Allows the client to assign a reward
         * @param {AssignRewardRequestDto} assignRewardRequestDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignReward: (assignRewardRequestDto, program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'assignRewardRequestDto' is not null or undefined
            common_1.assertParamExists('assignReward', 'assignRewardRequestDto', assignRewardRequestDto);
            const localVarPath = `/v1/contingency-management/assign-reward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (program !== undefined && program !== null) {
                localVarHeaderParameter['program'] = String(program);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(assignRewardRequestDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the client to obtain a given user\'s Contingency Management patient summary
         * @param {any} prescriptionId Prescription or access right id
         * @param {any} patientId Papi patient or auth user id
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cmPatientSummary: (prescriptionId, patientId, program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'prescriptionId' is not null or undefined
            common_1.assertParamExists('cmPatientSummary', 'prescriptionId', prescriptionId);
            // verify required parameter 'patientId' is not null or undefined
            common_1.assertParamExists('cmPatientSummary', 'patientId', patientId);
            const localVarPath = `/v1/contingency-management/patient-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (prescriptionId !== undefined) {
                localVarQueryParameter['prescriptionId'] = prescriptionId;
            }
            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }
            if (program !== undefined && program !== null) {
                localVarHeaderParameter['program'] = String(program);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the client to obtain a given user\'s Contingency Management summary
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cmSummary: (program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/contingency-management/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (program !== undefined && program !== null) {
                localVarHeaderParameter['program'] = String(program);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Creates a new document acceptance for the current patient and prescription.
         * @param {DocumentAcceptanceCreateDto} documentAcceptanceCreateDto The document acceptance to create.
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCurrentPatientDocumentAcceptance: (documentAcceptanceCreateDto, program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'documentAcceptanceCreateDto' is not null or undefined
            common_1.assertParamExists('createCurrentPatientDocumentAcceptance', 'documentAcceptanceCreateDto', documentAcceptanceCreateDto);
            const localVarPath = `/v1/patients/current/document-acceptance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (program !== undefined && program !== null) {
                localVarHeaderParameter['program'] = String(program);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(documentAcceptanceCreateDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the client to purchase a gift card for a given user
         * @param {CreateGiftCardDto} createGiftCardDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGiftCard: (createGiftCardDto, program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createGiftCardDto' is not null or undefined
            common_1.assertParamExists('createGiftCard', 'createGiftCardDto', createGiftCardDto);
            const localVarPath = `/v1/contingency-management/gift-card`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (program !== undefined && program !== null) {
                localVarHeaderParameter['program'] = String(program);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createGiftCardDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Creates or updates the appointment compliance for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {AppointmentComplianceCreateDto} appointmentComplianceCreateDto The appointment compliance to create or update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientAppointmentCompliance: (id, accessRightId, appointmentComplianceCreateDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('createPatientAppointmentCompliance', 'id', id);
            // verify required parameter 'accessRightId' is not null or undefined
            common_1.assertParamExists('createPatientAppointmentCompliance', 'accessRightId', accessRightId);
            // verify required parameter 'appointmentComplianceCreateDto' is not null or undefined
            common_1.assertParamExists('createPatientAppointmentCompliance', 'appointmentComplianceCreateDto', appointmentComplianceCreateDto);
            const localVarPath = `/v1/patients/{id}/access-rights/{accessRightId}/appointment-compliances`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"accessRightId"}}`, encodeURIComponent(String(accessRightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(appointmentComplianceCreateDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Creates or updates the cleen screen compliance for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {CleanScreenComplianceCreateDto} cleanScreenComplianceCreateDto The clean screen compliance to create or update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientCleanScreenCompliance: (id, accessRightId, cleanScreenComplianceCreateDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('createPatientCleanScreenCompliance', 'id', id);
            // verify required parameter 'accessRightId' is not null or undefined
            common_1.assertParamExists('createPatientCleanScreenCompliance', 'accessRightId', accessRightId);
            // verify required parameter 'cleanScreenComplianceCreateDto' is not null or undefined
            common_1.assertParamExists('createPatientCleanScreenCompliance', 'cleanScreenComplianceCreateDto', cleanScreenComplianceCreateDto);
            const localVarPath = `/v1/patients/{id}/access-rights/{accessRightId}/clean-screen-compliances`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"accessRightId"}}`, encodeURIComponent(String(accessRightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(cleanScreenComplianceCreateDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagnosisCheck: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/diagnosis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the clinical content for the given program/product
         * @param {string} program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentForProgram: (program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'program' is not null or undefined
            common_1.assertParamExists('getContentForProgram', 'program', program);
            const localVarPath = `/content/{program}`
                .replace(`{${"program"}}`, encodeURIComponent(String(program)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the current patient data based on request authorization header
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentPatient: (program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/patients/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (program !== undefined && program !== null) {
                localVarHeaderParameter['program'] = String(program);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the craving and use data for the current patients active prescription based on request authorization header
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentPatientCravingChart: (program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/patients/current/craving-chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (program !== undefined && program !== null) {
                localVarHeaderParameter['program'] = String(program);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the appointment compliances for the paitent with the given id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAppointmentCompliances: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getPatientAppointmentCompliances', 'id', id);
            const localVarPath = `/v1/patients/{id}/appointment-compliances`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the craving and use data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientCravingAndUseSummary: (id, accessRightId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getPatientCravingAndUseSummary', 'id', id);
            // verify required parameter 'accessRightId' is not null or undefined
            common_1.assertParamExists('getPatientCravingAndUseSummary', 'accessRightId', accessRightId);
            const localVarPath = `/v1/patients/{id}/access-rights/{accessRightId}/craving-and-uses`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"accessRightId"}}`, encodeURIComponent(String(accessRightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the curriculum progress data for the patient with the given id and access right id
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientCurriculumProgress: (id, accessRightId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getPatientCurriculumProgress', 'id', id);
            // verify required parameter 'accessRightId' is not null or undefined
            common_1.assertParamExists('getPatientCurriculumProgress', 'accessRightId', accessRightId);
            const localVarPath = `/v1/patients/{id}/access-rights/{accessRightId}/curriculum-progress`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"accessRightId"}}`, encodeURIComponent(String(accessRightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the event data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientEvents: (id, accessRightId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getPatientEvents', 'id', id);
            // verify required parameter 'accessRightId' is not null or undefined
            common_1.assertParamExists('getPatientEvents', 'accessRightId', accessRightId);
            const localVarPath = `/v1/patients/{id}/access-rights/{accessRightId}/events`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"accessRightId"}}`, encodeURIComponent(String(accessRightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the summary data for the patient with the given id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInfo: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getPatientInfo', 'id', id);
            const localVarPath = `/v1/patients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the overview data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientOverview: (id, accessRightId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getPatientOverview', 'id', id);
            // verify required parameter 'accessRightId' is not null or undefined
            common_1.assertParamExists('getPatientOverview', 'accessRightId', accessRightId);
            const localVarPath = `/v1/patients/{id}/access-rights/{accessRightId}/overview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"accessRightId"}}`, encodeURIComponent(String(accessRightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the client to obtain a given user\'s Prescription Configuration
         * @param {any} prescriptionId Prescription ID
         * @param {any} patientId Patient ID
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPrescriptionConfiguration: (prescriptionId, patientId, program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'prescriptionId' is not null or undefined
            common_1.assertParamExists('getPatientPrescriptionConfiguration', 'prescriptionId', prescriptionId);
            // verify required parameter 'patientId' is not null or undefined
            common_1.assertParamExists('getPatientPrescriptionConfiguration', 'patientId', patientId);
            const localVarPath = `/v1/contingency-management/prescription-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (prescriptionId !== undefined) {
                localVarQueryParameter['prescriptionId'] = prescriptionId;
            }
            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }
            if (program !== undefined && program !== null) {
                localVarHeaderParameter['program'] = String(program);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the rewards data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientRewards: (id, accessRightId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getPatientRewards', 'id', id);
            // verify required parameter 'accessRightId' is not null or undefined
            common_1.assertParamExists('getPatientRewards', 'accessRightId', accessRightId);
            const localVarPath = `/v1/patients/{id}/access-rights/{accessRightId}/rewards`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"accessRightId"}}`, encodeURIComponent(String(accessRightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the snapshot data for the patient with the given id and access right id
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSnapshot: (id, accessRightId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getPatientSnapshot', 'id', id);
            // verify required parameter 'accessRightId' is not null or undefined
            common_1.assertParamExists('getPatientSnapshot', 'accessRightId', accessRightId);
            const localVarPath = `/v1/patients/{id}/access-rights/{accessRightId}/snapshot`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"accessRightId"}}`, encodeURIComponent(String(accessRightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the snapshot pdf for the patient with the given id and access right id
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSnapshotPdf: (id, accessRightId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getPatientSnapshotPdf', 'id', id);
            // verify required parameter 'accessRightId' is not null or undefined
            common_1.assertParamExists('getPatientSnapshotPdf', 'accessRightId', accessRightId);
            const localVarPath = `/v1/patients/{id}/access-rights/{accessRightId}/snapshot/pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"accessRightId"}}`, encodeURIComponent(String(accessRightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the usage report data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientUsageReport: (id, accessRightId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getPatientUsageReport', 'id', id);
            // verify required parameter 'accessRightId' is not null or undefined
            common_1.assertParamExists('getPatientUsageReport', 'accessRightId', accessRightId);
            const localVarPath = `/v1/patients/{id}/access-rights/{accessRightId}/usage-report`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"accessRightId"}}`, encodeURIComponent(String(accessRightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the weekly lesson progress summary data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentProgressSummary: (id, accessRightId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getTreatmentProgressSummary', 'id', id);
            // verify required parameter 'accessRightId' is not null or undefined
            common_1.assertParamExists('getTreatmentProgressSummary', 'accessRightId', accessRightId);
            const localVarPath = `/v1/patients/{id}/access-rights/{accessRightId}/treatment-progress-summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"accessRightId"}}`, encodeURIComponent(String(accessRightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        livenessCheck: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the client to register a reward with no value
         * @param {AssignRewardRequestDto} assignRewardRequestDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNoValueReward: (assignRewardRequestDto, program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'assignRewardRequestDto' is not null or undefined
            common_1.assertParamExists('postNoValueReward', 'assignRewardRequestDto', assignRewardRequestDto);
            const localVarPath = `/v1/contingency-management/register-no-value-reward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (program !== undefined && program !== null) {
                localVarHeaderParameter['program'] = String(program);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(assignRewardRequestDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the client to register a reward with no value
         * @param {AssignRewardRequestDto} assignRewardRequestDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNoValueReward: (assignRewardRequestDto, program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'assignRewardRequestDto' is not null or undefined
            common_1.assertParamExists('registerNoValueReward', 'assignRewardRequestDto', assignRewardRequestDto);
            const localVarPath = `/v1/contingency-management/register-no-value-reward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (program !== undefined && program !== null) {
                localVarHeaderParameter['program'] = String(program);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(assignRewardRequestDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the client to report a $0 reward for a given user
         * @param {NoValueRewardDto} noValueRewardDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportNoValueReward: (noValueRewardDto, program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'noValueRewardDto' is not null or undefined
            common_1.assertParamExists('reportNoValueReward', 'noValueRewardDto', noValueRewardDto);
            const localVarPath = `/v1/contingency-management/report-no-value-reward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (program !== undefined && program !== null) {
                localVarHeaderParameter['program'] = String(program);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(noValueRewardDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the client to mark a user\'s gift card as depleted or not depleted
         * @param {UpdateGiftCardDto} updateGiftCardDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGiftCard: (updateGiftCardDto, program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateGiftCardDto' is not null or undefined
            common_1.assertParamExists('updateGiftCard', 'updateGiftCardDto', updateGiftCardDto);
            const localVarPath = `/v1/contingency-management/gift-card`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (program !== undefined && program !== null) {
                localVarHeaderParameter['program'] = String(program);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateGiftCardDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the client to mark a reward as assigned for a given user
         * @param {UpdateRewardDto} updateRewardDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReward: (updateRewardDto, program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateRewardDto' is not null or undefined
            common_1.assertParamExists('updateReward', 'updateRewardDto', updateRewardDto);
            const localVarPath = `/v1/contingency-management/reward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication userKey required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (program !== undefined && program !== null) {
                localVarHeaderParameter['program'] = String(program);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateRewardDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
exports.DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Allows the client to assign a reward
         * @param {AssignRewardRequestDto} assignRewardRequestDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignReward(assignRewardRequestDto, program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assignReward(assignRewardRequestDto, program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the client to obtain a given user\'s Contingency Management patient summary
         * @param {any} prescriptionId Prescription or access right id
         * @param {any} patientId Papi patient or auth user id
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cmPatientSummary(prescriptionId, patientId, program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cmPatientSummary(prescriptionId, patientId, program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the client to obtain a given user\'s Contingency Management summary
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cmSummary(program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cmSummary(program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Creates a new document acceptance for the current patient and prescription.
         * @param {DocumentAcceptanceCreateDto} documentAcceptanceCreateDto The document acceptance to create.
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCurrentPatientDocumentAcceptance(documentAcceptanceCreateDto, program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCurrentPatientDocumentAcceptance(documentAcceptanceCreateDto, program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the client to purchase a gift card for a given user
         * @param {CreateGiftCardDto} createGiftCardDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGiftCard(createGiftCardDto, program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createGiftCard(createGiftCardDto, program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Creates or updates the appointment compliance for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {AppointmentComplianceCreateDto} appointmentComplianceCreateDto The appointment compliance to create or update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientAppointmentCompliance(id, accessRightId, appointmentComplianceCreateDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPatientAppointmentCompliance(id, accessRightId, appointmentComplianceCreateDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Creates or updates the cleen screen compliance for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {CleanScreenComplianceCreateDto} cleanScreenComplianceCreateDto The clean screen compliance to create or update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientCleanScreenCompliance(id, accessRightId, cleanScreenComplianceCreateDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPatientCleanScreenCompliance(id, accessRightId, cleanScreenComplianceCreateDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagnosisCheck(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.diagnosisCheck(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the clinical content for the given program/product
         * @param {string} program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentForProgram(program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getContentForProgram(program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the current patient data based on request authorization header
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentPatient(program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentPatient(program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the craving and use data for the current patients active prescription based on request authorization header
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentPatientCravingChart(program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentPatientCravingChart(program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the appointment compliances for the paitent with the given id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAppointmentCompliances(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPatientAppointmentCompliances(id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the craving and use data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientCravingAndUseSummary(id, accessRightId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPatientCravingAndUseSummary(id, accessRightId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the curriculum progress data for the patient with the given id and access right id
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientCurriculumProgress(id, accessRightId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPatientCurriculumProgress(id, accessRightId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the event data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientEvents(id, accessRightId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPatientEvents(id, accessRightId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the summary data for the patient with the given id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInfo(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPatientInfo(id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the overview data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientOverview(id, accessRightId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPatientOverview(id, accessRightId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the client to obtain a given user\'s Prescription Configuration
         * @param {any} prescriptionId Prescription ID
         * @param {any} patientId Patient ID
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPrescriptionConfiguration(prescriptionId, patientId, program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPatientPrescriptionConfiguration(prescriptionId, patientId, program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the rewards data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientRewards(id, accessRightId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPatientRewards(id, accessRightId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the snapshot data for the patient with the given id and access right id
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSnapshot(id, accessRightId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPatientSnapshot(id, accessRightId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the snapshot pdf for the patient with the given id and access right id
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSnapshotPdf(id, accessRightId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPatientSnapshotPdf(id, accessRightId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the usage report data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientUsageReport(id, accessRightId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPatientUsageReport(id, accessRightId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the weekly lesson progress summary data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentProgressSummary(id, accessRightId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTreatmentProgressSummary(id, accessRightId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        livenessCheck(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.livenessCheck(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the client to register a reward with no value
         * @param {AssignRewardRequestDto} assignRewardRequestDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNoValueReward(assignRewardRequestDto, program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postNoValueReward(assignRewardRequestDto, program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the client to register a reward with no value
         * @param {AssignRewardRequestDto} assignRewardRequestDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNoValueReward(assignRewardRequestDto, program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerNoValueReward(assignRewardRequestDto, program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the client to report a $0 reward for a given user
         * @param {NoValueRewardDto} noValueRewardDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportNoValueReward(noValueRewardDto, program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportNoValueReward(noValueRewardDto, program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the client to mark a user\'s gift card as depleted or not depleted
         * @param {UpdateGiftCardDto} updateGiftCardDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGiftCard(updateGiftCardDto, program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateGiftCard(updateGiftCardDto, program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the client to mark a reward as assigned for a given user
         * @param {UpdateRewardDto} updateRewardDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReward(updateRewardDto, program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateReward(updateRewardDto, program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
exports.DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.DefaultApiFp(configuration);
    return {
        /**
         *
         * @summary Allows the client to assign a reward
         * @param {AssignRewardRequestDto} assignRewardRequestDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignReward(assignRewardRequestDto, program, options) {
            return localVarFp.assignReward(assignRewardRequestDto, program, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the client to obtain a given user\'s Contingency Management patient summary
         * @param {any} prescriptionId Prescription or access right id
         * @param {any} patientId Papi patient or auth user id
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cmPatientSummary(prescriptionId, patientId, program, options) {
            return localVarFp.cmPatientSummary(prescriptionId, patientId, program, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the client to obtain a given user\'s Contingency Management summary
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cmSummary(program, options) {
            return localVarFp.cmSummary(program, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates a new document acceptance for the current patient and prescription.
         * @param {DocumentAcceptanceCreateDto} documentAcceptanceCreateDto The document acceptance to create.
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCurrentPatientDocumentAcceptance(documentAcceptanceCreateDto, program, options) {
            return localVarFp.createCurrentPatientDocumentAcceptance(documentAcceptanceCreateDto, program, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the client to purchase a gift card for a given user
         * @param {CreateGiftCardDto} createGiftCardDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGiftCard(createGiftCardDto, program, options) {
            return localVarFp.createGiftCard(createGiftCardDto, program, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates or updates the appointment compliance for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {AppointmentComplianceCreateDto} appointmentComplianceCreateDto The appointment compliance to create or update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientAppointmentCompliance(id, accessRightId, appointmentComplianceCreateDto, options) {
            return localVarFp.createPatientAppointmentCompliance(id, accessRightId, appointmentComplianceCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates or updates the cleen screen compliance for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {CleanScreenComplianceCreateDto} cleanScreenComplianceCreateDto The clean screen compliance to create or update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientCleanScreenCompliance(id, accessRightId, cleanScreenComplianceCreateDto, options) {
            return localVarFp.createPatientCleanScreenCompliance(id, accessRightId, cleanScreenComplianceCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagnosisCheck(options) {
            return localVarFp.diagnosisCheck(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the clinical content for the given program/product
         * @param {string} program
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentForProgram(program, options) {
            return localVarFp.getContentForProgram(program, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the current patient data based on request authorization header
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentPatient(program, options) {
            return localVarFp.getCurrentPatient(program, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the craving and use data for the current patients active prescription based on request authorization header
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentPatientCravingChart(program, options) {
            return localVarFp.getCurrentPatientCravingChart(program, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the appointment compliances for the paitent with the given id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAppointmentCompliances(id, options) {
            return localVarFp.getPatientAppointmentCompliances(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the craving and use data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientCravingAndUseSummary(id, accessRightId, options) {
            return localVarFp.getPatientCravingAndUseSummary(id, accessRightId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the curriculum progress data for the patient with the given id and access right id
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientCurriculumProgress(id, accessRightId, options) {
            return localVarFp.getPatientCurriculumProgress(id, accessRightId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the event data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientEvents(id, accessRightId, options) {
            return localVarFp.getPatientEvents(id, accessRightId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the summary data for the patient with the given id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInfo(id, options) {
            return localVarFp.getPatientInfo(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the overview data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientOverview(id, accessRightId, options) {
            return localVarFp.getPatientOverview(id, accessRightId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the client to obtain a given user\'s Prescription Configuration
         * @param {any} prescriptionId Prescription ID
         * @param {any} patientId Patient ID
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPrescriptionConfiguration(prescriptionId, patientId, program, options) {
            return localVarFp.getPatientPrescriptionConfiguration(prescriptionId, patientId, program, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the rewards data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientRewards(id, accessRightId, options) {
            return localVarFp.getPatientRewards(id, accessRightId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the snapshot data for the patient with the given id and access right id
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSnapshot(id, accessRightId, options) {
            return localVarFp.getPatientSnapshot(id, accessRightId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the snapshot pdf for the patient with the given id and access right id
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSnapshotPdf(id, accessRightId, options) {
            return localVarFp.getPatientSnapshotPdf(id, accessRightId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the usage report data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientUsageReport(id, accessRightId, options) {
            return localVarFp.getPatientUsageReport(id, accessRightId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the weekly lesson progress summary data for the patient with the given id and access right id.
         * @param {string} id
         * @param {string} accessRightId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentProgressSummary(id, accessRightId, options) {
            return localVarFp.getTreatmentProgressSummary(id, accessRightId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        livenessCheck(options) {
            return localVarFp.livenessCheck(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the client to register a reward with no value
         * @param {AssignRewardRequestDto} assignRewardRequestDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNoValueReward(assignRewardRequestDto, program, options) {
            return localVarFp.postNoValueReward(assignRewardRequestDto, program, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the client to register a reward with no value
         * @param {AssignRewardRequestDto} assignRewardRequestDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNoValueReward(assignRewardRequestDto, program, options) {
            return localVarFp.registerNoValueReward(assignRewardRequestDto, program, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the client to report a $0 reward for a given user
         * @param {NoValueRewardDto} noValueRewardDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportNoValueReward(noValueRewardDto, program, options) {
            return localVarFp.reportNoValueReward(noValueRewardDto, program, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the client to mark a user\'s gift card as depleted or not depleted
         * @param {UpdateGiftCardDto} updateGiftCardDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGiftCard(updateGiftCardDto, program, options) {
            return localVarFp.updateGiftCard(updateGiftCardDto, program, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the client to mark a reward as assigned for a given user
         * @param {UpdateRewardDto} updateRewardDto
         * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReward(updateRewardDto, program, options) {
            return localVarFp.updateReward(updateRewardDto, program, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @summary Allows the client to assign a reward
     * @param {AssignRewardRequestDto} assignRewardRequestDto
     * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    assignReward(assignRewardRequestDto, program, options) {
        return exports.DefaultApiFp(this.configuration).assignReward(assignRewardRequestDto, program, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the client to obtain a given user\'s Contingency Management patient summary
     * @param {any} prescriptionId Prescription or access right id
     * @param {any} patientId Papi patient or auth user id
     * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    cmPatientSummary(prescriptionId, patientId, program, options) {
        return exports.DefaultApiFp(this.configuration).cmPatientSummary(prescriptionId, patientId, program, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the client to obtain a given user\'s Contingency Management summary
     * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    cmSummary(program, options) {
        return exports.DefaultApiFp(this.configuration).cmSummary(program, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates a new document acceptance for the current patient and prescription.
     * @param {DocumentAcceptanceCreateDto} documentAcceptanceCreateDto The document acceptance to create.
     * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createCurrentPatientDocumentAcceptance(documentAcceptanceCreateDto, program, options) {
        return exports.DefaultApiFp(this.configuration).createCurrentPatientDocumentAcceptance(documentAcceptanceCreateDto, program, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the client to purchase a gift card for a given user
     * @param {CreateGiftCardDto} createGiftCardDto
     * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createGiftCard(createGiftCardDto, program, options) {
        return exports.DefaultApiFp(this.configuration).createGiftCard(createGiftCardDto, program, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates or updates the appointment compliance for the patient with the given id and access right id.
     * @param {string} id
     * @param {string} accessRightId
     * @param {AppointmentComplianceCreateDto} appointmentComplianceCreateDto The appointment compliance to create or update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createPatientAppointmentCompliance(id, accessRightId, appointmentComplianceCreateDto, options) {
        return exports.DefaultApiFp(this.configuration).createPatientAppointmentCompliance(id, accessRightId, appointmentComplianceCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates or updates the cleen screen compliance for the patient with the given id and access right id.
     * @param {string} id
     * @param {string} accessRightId
     * @param {CleanScreenComplianceCreateDto} cleanScreenComplianceCreateDto The clean screen compliance to create or update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createPatientCleanScreenCompliance(id, accessRightId, cleanScreenComplianceCreateDto, options) {
        return exports.DefaultApiFp(this.configuration).createPatientCleanScreenCompliance(id, accessRightId, cleanScreenComplianceCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    diagnosisCheck(options) {
        return exports.DefaultApiFp(this.configuration).diagnosisCheck(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the clinical content for the given program/product
     * @param {string} program
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getContentForProgram(program, options) {
        return exports.DefaultApiFp(this.configuration).getContentForProgram(program, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the current patient data based on request authorization header
     * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCurrentPatient(program, options) {
        return exports.DefaultApiFp(this.configuration).getCurrentPatient(program, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the craving and use data for the current patients active prescription based on request authorization header
     * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCurrentPatientCravingChart(program, options) {
        return exports.DefaultApiFp(this.configuration).getCurrentPatientCravingChart(program, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the appointment compliances for the paitent with the given id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPatientAppointmentCompliances(id, options) {
        return exports.DefaultApiFp(this.configuration).getPatientAppointmentCompliances(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the craving and use data for the patient with the given id and access right id.
     * @param {string} id
     * @param {string} accessRightId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPatientCravingAndUseSummary(id, accessRightId, options) {
        return exports.DefaultApiFp(this.configuration).getPatientCravingAndUseSummary(id, accessRightId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the curriculum progress data for the patient with the given id and access right id
     * @param {string} id
     * @param {string} accessRightId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPatientCurriculumProgress(id, accessRightId, options) {
        return exports.DefaultApiFp(this.configuration).getPatientCurriculumProgress(id, accessRightId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the event data for the patient with the given id and access right id.
     * @param {string} id
     * @param {string} accessRightId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPatientEvents(id, accessRightId, options) {
        return exports.DefaultApiFp(this.configuration).getPatientEvents(id, accessRightId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the summary data for the patient with the given id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPatientInfo(id, options) {
        return exports.DefaultApiFp(this.configuration).getPatientInfo(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the overview data for the patient with the given id and access right id.
     * @param {string} id
     * @param {string} accessRightId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPatientOverview(id, accessRightId, options) {
        return exports.DefaultApiFp(this.configuration).getPatientOverview(id, accessRightId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the client to obtain a given user\'s Prescription Configuration
     * @param {any} prescriptionId Prescription ID
     * @param {any} patientId Patient ID
     * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPatientPrescriptionConfiguration(prescriptionId, patientId, program, options) {
        return exports.DefaultApiFp(this.configuration).getPatientPrescriptionConfiguration(prescriptionId, patientId, program, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the rewards data for the patient with the given id and access right id.
     * @param {string} id
     * @param {string} accessRightId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPatientRewards(id, accessRightId, options) {
        return exports.DefaultApiFp(this.configuration).getPatientRewards(id, accessRightId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the snapshot data for the patient with the given id and access right id
     * @param {string} id
     * @param {string} accessRightId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPatientSnapshot(id, accessRightId, options) {
        return exports.DefaultApiFp(this.configuration).getPatientSnapshot(id, accessRightId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the snapshot pdf for the patient with the given id and access right id
     * @param {string} id
     * @param {string} accessRightId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPatientSnapshotPdf(id, accessRightId, options) {
        return exports.DefaultApiFp(this.configuration).getPatientSnapshotPdf(id, accessRightId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the usage report data for the patient with the given id and access right id.
     * @param {string} id
     * @param {string} accessRightId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPatientUsageReport(id, accessRightId, options) {
        return exports.DefaultApiFp(this.configuration).getPatientUsageReport(id, accessRightId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the weekly lesson progress summary data for the patient with the given id and access right id.
     * @param {string} id
     * @param {string} accessRightId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getTreatmentProgressSummary(id, accessRightId, options) {
        return exports.DefaultApiFp(this.configuration).getTreatmentProgressSummary(id, accessRightId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    livenessCheck(options) {
        return exports.DefaultApiFp(this.configuration).livenessCheck(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the client to register a reward with no value
     * @param {AssignRewardRequestDto} assignRewardRequestDto
     * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    postNoValueReward(assignRewardRequestDto, program, options) {
        return exports.DefaultApiFp(this.configuration).postNoValueReward(assignRewardRequestDto, program, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the client to register a reward with no value
     * @param {AssignRewardRequestDto} assignRewardRequestDto
     * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    registerNoValueReward(assignRewardRequestDto, program, options) {
        return exports.DefaultApiFp(this.configuration).registerNoValueReward(assignRewardRequestDto, program, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the client to report a $0 reward for a given user
     * @param {NoValueRewardDto} noValueRewardDto
     * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportNoValueReward(noValueRewardDto, program, options) {
        return exports.DefaultApiFp(this.configuration).reportNoValueReward(noValueRewardDto, program, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the client to mark a user\'s gift card as depleted or not depleted
     * @param {UpdateGiftCardDto} updateGiftCardDto
     * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateGiftCard(updateGiftCardDto, program, options) {
        return exports.DefaultApiFp(this.configuration).updateGiftCard(updateGiftCardDto, program, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the client to mark a reward as assigned for a given user
     * @param {UpdateRewardDto} updateRewardDto
     * @param {'reSET' | 'reSET-O' | 'pear-002a'} [program] The PDT - reSET, reSET-O, pear-002a
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateReward(updateRewardDto, program, options) {
        return exports.DefaultApiFp(this.configuration).updateReward(updateRewardDto, program, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
